import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/apt/v3/apt-v3.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/blog/ds2-blog.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/blog/region/region.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/apt/sub/apt-sub.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blog/BlogRegionCookieRestore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blog/BlogRegionCookieSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/FooterTalkLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds/e/HeaderAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/SegmentTabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/CardImg.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/ds2.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/kd/media/KdMediaFade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/kd/media/KdRegionBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shell/kd-shell.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/thumb/Thumb.tsx");
